var swymCallbackExecuted = false;

function onSwymLoadCallback(swat) {
  if (swymCallbackExecuted) return;
  swymCallbackExecuted = true;

  swat.fetchLists({
    callbackFn: function (lists) {
      if (!lists || lists.length === 0) {
        let listConfig = { "lname": "MY WISHLIST" };

        swat.createList(listConfig, 
          function(newList) { 
            console.log("✅ Successfully created a new List", newList);
            window.globalListArray = [newList];
            window.dispatchEvent(new CustomEvent('wishlistdata', { detail: [newList] }));
            persistWishlistButtonsState([newList]);
          },
          function(error) {
            console.error("❌ Error while creating a List", error);
          }
        );
      } else {
        window.globalListArray = lists;
        console.log("✅ Wishlist(s) loaded:", lists);
        window.dispatchEvent(new CustomEvent('wishlistdata', { detail: lists }));
        persistWishlistButtonsState(lists);
      }
    },
    errorFn: function (err) {
      console.error("❌ Error fetching wishlists:", err);
    }
  });
}

function persistWishlistButtonsState(lists) {
  lists.forEach((list) => {
    if (!list.listcontents) return;
    list.listcontents.forEach((product) => {
      let productId = product.empi;
      let buttonToFill = document.querySelector(`button#swym-collections[data-product-id="${productId}"]`);
      let productButtonToFill = document.querySelector(`button#swym-product[data-product-id="${productId}"]`);
      if (buttonToFill && !buttonToFill.classList.contains('swym-added')) {
        SwymUtils.addClass(buttonToFill, "swym-added");
      }
      if (productButtonToFill && !productButtonToFill.classList.contains('swym-added')) {
        SwymUtils.addClass(productButtonToFill, "swym-added");
      }
    });
  });
}

if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push(onSwymLoadCallback);
document.addEventListener("wishRefresh", () => {
  swymCallbackExecuted = false;
  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(onSwymLoadCallback);
});

function handleSingleWishlist(product, button) {
  if (!window.globalListArray || !globalListArray[0]) {
    window.addEventListener('wishlistdata', function handler() {
      window.removeEventListener('wishlistdata', handler);
      handleSingleWishlist(product, button);
    });
    return;
  }

  const lid = globalListArray[0].lid;

  const onSuccess = function () {
    button.classList.toggle("swym-added");
    console.log(
      button.classList.contains("swym-added")
        ? "Product added to wishlist"
        : "Product removed from wishlist"
    );
  };

  const onError = function (error) {
    console.log("Error while adding/removing the product", error);
  };

  if (!button.classList.contains("swym-added")) { 
    _swat.addToList(lid, product, onSuccess, onError);
    wishPopNoti(product);
  } else {
    _swat.deleteFromList(lid, product, onSuccess, onError); 
  }
}

function attachWishlistListeners() {
  const wishButtons = document.querySelectorAll(".swym-button");
  wishButtons.forEach((button) => {
    button.removeEventListener("click", handleWishlistClick);
    button.addEventListener("click", handleWishlistClick);
  });
}

function handleWishlistClick(event) {
  const button = event.currentTarget;
  const product = {
    empi: button.getAttribute("data-product-id"),
    epi: button.getAttribute("data-variant-id"),
    du: button.getAttribute("data-product-url"),
  };
  handleSingleWishlist(product, button);
}

document.addEventListener("DOMContentLoaded", attachWishlistListeners);
document.addEventListener("wishRefresh", attachWishlistListeners);

async function wishPopNoti(product) {
  let mainWishNoti = document.querySelector(".WI_wiahNoti_main");
  let inWishNoti = document.querySelector(".WI_wiahNoti_in");
  let url = (product.du).split('?')[0];
  try {
    let res = await fetch(url + ".json");
    let data = await res.json();
    var wishNotiProTitle = data.product.title;
    var wishNotiProImg = data.product.images[0].src;
  } catch (error) {
    console.error("Error in wishPopNoti:", error);
  }
  inWishNoti.querySelector(".WI_wiahNoti_img_src").src = wishNotiProImg;
  inWishNoti.querySelector(".WI_wiahNoti_text_title").innerText = wishNotiProTitle;
  mainWishNoti.style.display = "flex";
  setTimeout(() => {
    inWishNoti.style.opacity = "1";
    inWishNoti.style.transform = "translateX(0)";
  }, 10);
  setTimeout(() => {
    inWishNoti.style.opacity = "0";
    inWishNoti.style.transform = "translateX(100%)";
    setTimeout(() => {
      mainWishNoti.style.display = "none";
    }, 210);
  }, 2510);
}